import React, { useEffect, useRef, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Datagrid from '../ui/Datagrid';
import { gridClasses } from '@mui/x-data-grid';
import columns from './table_config';
import { listTargetAnswers } from '../../store/actions/targetAnswers';
import { Grid } from '@mui/material';
import { renderCell } from '../ui/Datagrid/table_config';
import PropTypes from 'prop-types';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import { REDUX_ACTIONS } from '../../shared/config/constants';

const useQuery = () => {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
};

const TargetAnswers = () => {
  const targetAnswers = useSelector((state) => state.targetAnswers);
  const { loading, data, searchValue } = targetAnswers;
  const apiRef = useGridApiRef();
  const dispatch = useDispatch();
  const fetchedRef = useRef({});

  const query = useQuery();
  const question = query.get('question');
  const referenceCategory = query.get('category');

  useEffect(() => {
    if (!question) return;

    if (fetchedRef.current[question]) return;
    fetchedRef.current[question] = true;

    dispatch({
      type: REDUX_ACTIONS.MENU_SET_TITLE,
      payload: question,
    });
    dispatch(listTargetAnswers({ question, referenceCategory }));
  }, [dispatch, loading, question]);

  const filteredData = useMemo(() => {
    if (!searchValue || !searchValue.trim()) {
      return data;
    }

    const term = searchValue.trim().toLowerCase();

    return data.filter((row) => {
      const email = (row.userEmail || '').toLowerCase();
      const rig = (row.RigName_Number || '').toLowerCase();

      return email.includes(term) || rig.includes(term);
    });
  }, [data, searchValue]);

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12}>
        <Datagrid
          apiRef={apiRef}
          data={filteredData}
          autoHeight={false}
          columns={columns(renderCell)}
          loading={targetAnswers.loading}
          disableStickyHeader={false}
          onRowClick={() => {}}
          height={'90vh'}
          getRowId={(row) => row.grid_id}
          getRowHeight={() => 'auto'}
          autoPageSize
          pagination={false}
          hideFooter
          sx={{
            '.MuiDataGrid-columnHeaderTitle': {
              fontWeight: 'bold !important',
            },
            [`& .${gridClasses.cell}`]: {
              py: 1,
            },
          }}
          fileName={`${question}_answers`}
          toolbar={{
            options: {
              columns: true,
              filters: true,
              export: {
                enabled: true
              },
            },
          }}
        />
      </Grid>
    </Grid>
  );
};

TargetAnswers.propTypes = {
  row: PropTypes.object,
};

export default TargetAnswers;
